/**
 * Supported rate limit tiers for our external API, v2 (and up?).
 */
export enum ExternalAPIRateLimitTier {
  STANDARD = "standard",
  ENHANCED = "enhanced",
  MAX = "max",
}

export const ExternalAPIRateLimitTierValues = Object.values(ExternalAPIRateLimitTier);
